import Axios from "axios"

export const sendOTP = async(options) =>{
    const {token,mobile}= options
    return await Axios.get(`/vendorapis/delivery_boy/delivery/sendOtp?token=${token}&mobile=${mobile}`)
}

export const verifyOTP = async(options) =>{
    const {token,otp}= options
    return await Axios.get(`/vendorapis/delivery_boy/delivery/verifyOtp?token=${token}&otp=${otp}`)
}

export const deleteDeliveryBoy = async(options) =>{
    const {token,mobile}= options
    return await Axios.post(`/vendorapis/delivery_boy/delivery/deleteDeliveryAgent?token=${token}&mobile=${mobile}`)
}

export const editDeliveryBoy = async(options) =>{
    const {token,name,mobile,imageurl}= options
    return await Axios.post(`/vendorapis/delivery_boy/delivery/editDeliveryAgent?token=${token}&mobile=${mobile}&name=${name}&image=${imageurl}`)
}

export const createDeliveryBoy = async(options) =>{
    const {token,name,mobile,imageurl}= options
    return await Axios.get(`/vendorapis/delivery_boy/delivery/addDeliveryAgent?token=${token}&mobile=${mobile}&name=${name}&image=${imageurl}`)
}

export const getAllDeliveryBoy = async(options) =>{
    const {token,mobile}= options
    return await Axios.post(`/marketplace/marketplace-delivery-boy-api/listDeliveryAgents.ns?docid=080PXX80.XX80.211229114130.V1U5`)
}

export const getDeliveryCharge = async(options) =>{
    const {token}= options
    return await Axios.post(`/vendorapis/offer/offer/getDeliveryChargeDetails?token=${token}`)
}

export const setDeliveryCharge = async(options) =>{
    const {token,jsonData}= options
    console.log('jsonData',jsonData)
    return await Axios.post(`/vendorapis/offer/offer/setDeliveryChargeDetails?token=${token}&jsonData=${JSON.stringify(jsonData)}`)
}